import PropTypes from 'prop-types';
import Modal from 'react-modal';

const ModalWrapper = ({
  isOpen,
  closeModal,
  style,
  children,
  closeButtonColor = 'white',
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={style}
      ariaHideApp={false}
    >
      <div>
        <button
          type="button"
          onClick={closeModal}
          style={{
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            fontSize: '24px',
            position: 'absolute',
            color: closeButtonColor,
            right: '8px',
            top: '6px',
            zIndex: '9999',
          }}
        >
          &times;
        </button>
        {children}
      </div>
    </Modal>
  );
};

ModalWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  closeModal: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  closeButtonColor: PropTypes.string,
};

export default ModalWrapper;
